export default "__VITE_ASSET__c4dac49c__"